import React, { useState, useEffect, useContext } from 'react'
import { Row, Col, Button, Modal, CloseButton, Nav } from 'react-bootstrap'
import { Formik, Field, Form } from 'formik'
import * as Yup from 'yup'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import * as dayjs from 'dayjs'

import MetabolicPlanFormConfirm from './MetabolicPlanFormConfirm'
import MetabolicPlanFormView from './MetabolicPlanFormView'
import axios from 'axios'
import { AuthContext } from '../AuthContext'

const MetabolicPlanForm = ({
  caseModalShow,
  setCaseModalShow,
  currentPatient,
  warning,
  setWarning,
  setQrcode,
  setCaseClosedModalShow,
}) => {
  // const today = dayjs()

  const [formData, setFormData] = useState({
    name: '',
    gender: '',
    birthday: '',
    track_form: {
      info: {
        height: '',
        weight: '',
        exercise_habit_type: '',
        smoke_habit_type: '',
        betel_nut_habit_type: '',
      },
      chronic_risk: {
        cad_risk_type: '',
        diabetes_risk_type: '',
        hypertension_risk_type: '',
        stroke_risk_type: '',
        cvd_risk_type: '',
      },
      indicator: {
        waistline: '',
        blood_sugar_before_meal: '',
        sbp: '',
        dbp: '',
        tg: '',
        hdl: '',
        // bmi: '',
      },

      guidelines: {
        quit_smoking: {
          check: 0,
          quit_smoking_type: '',
          service_type: '',
        },
        quit_betel_nut: {
          check: 0,
          quit_betel_nut_type: '',
          target_date: '',
          oral_mucosa_check_date: '',
        },
        food: {
          check: 0,
          caloric_intake_type: '',
          caloric: '',
          reduce_food_type: [],
          other_food_type: '',
        },
        exercise: {
          check: 0,
          exercise_type: [],
          resource: [],
        },
        target_indicator: {
          check: 0,
          target_waistline: '',
          target_weight: '',
        },
        blood_pressure_check: 0,
        other: {
          check: 0,
          other_type: [],
          HbA1c_before_meal_target: '',
          blood_sugar_before_meal_target: '',
          tg_target: '',
          hdl_target: '',
          ldl_target: '',
        },
      },
    },
  })
  const [formConfirmShow, setFormConfirmShow] = useState(false)

  const { baseUrl, sendDiscordNotification, currentUser, extendCookie } =
    useContext(AuthContext)
  const getTrack = '/api/crm/project/track/getTrack'

  const [patient_id, setPatient_id] = useState(null)
  useEffect(() => {
    if (currentPatient) {
      setPatient_id(currentPatient.patient_id)
    }
  }, [currentPatient])

  // 病患追蹤
  const [trackFormData, setTrackFormData] = useState({
    name: '',
    gender: 0,
    birthday: '',
    clinic_name: '',
    next_appointment_time: '',
    track_type: 0,
    id_number: '',
    phone: '',
    data: [],
  })
  const [currentTrackIndex, setCurrentTrackIndex] = useState(1)
  const [isTrackDataLoaded, setIsTrackDataLoaded] = useState(false)
  const [lastTrackFormData, setLastTrackFormData] = useState({
    name: '',
    gender: 0,
    birthday: '',
    track_form: {
      info: {
        height: '',
        weight: '',
        exercise_habit_type: '',
        smoke_habit_type: '',
        betel_nut_habit_type: '',
      },
      chronic_risk: {
        cad_risk_type: '',
        diabetes_risk_type: '',
        hypertension_risk_type: '',
        stroke_risk_type: '',
        cvd_risk_type: '',
      },
      indicator: {
        waistline: '',
        blood_sugar_before_meal: '',
        sbp: '',
        dbp: '',
        tg: '',
        hdl: '',
        // bmi: '',
      },
      guidelines: {
        quit_smoking: {
          check: 0,
          quit_smoking_type: '',
          service_type: '',
        },
        quit_betel_nut: {
          check: 0,
          quit_betel_nut_type: '',
          target_date: '',
          oral_mucosa_check_date: '',
        },
        food: {
          check: 0,
          caloric_intake_type: '',
          caloric: '',
          reduce_food_type: [],
          other_food_type: '',
        },
        exercise: {
          check: 0,
          exercise_type: [],
          resource: [],
        },
        target_indicator: {
          check: 0,
          target_waistline: '',
          target_weight: '',
        },
        blood_pressure_check: 0,
        other: {
          check: 0,
          other_type: [],
          HbA1c_before_meal_target: '',
          blood_sugar_before_meal_target: '',
          tg_target: '',
          hdl_target: '',
          ldl_target: '',
        },
      },
    },
  })
  useEffect(() => {
    if (currentUser && currentUser.session) {
      let loadingTimer

      loadingTimer = setTimeout(() => {
        // setIsCardLoading(true)
      }, 500)

      if (patient_id) {
        axios
          .post(
            baseUrl + getTrack,
            {
              project_id: 'P0001',
              patient_id: patient_id,
              clinic_id: currentUser.clinic_id,
            },
            {
              headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                Accept: '*/*',
                session: currentUser.session,
              },
            }
          )
          .then((res) => {
            if (res.data) {
              console.log('getTrack', res.data)
              setTrackFormData(res.data)
              setCurrentTrackIndex(res.data.data.length)
              const { name, gender, birthday, data, id_number, phone } =
                res.data
              const { info, chronic_risk } =
                data[res.data.data.length - 1].track_form
              setLastTrackFormData({
                ...lastTrackFormData,
                name: name,
                gender: gender,
                birthday: birthday,
                id_number: id_number,
                phone: phone,
                track_form: {
                  ...lastTrackFormData.track_form,
                  info: info,
                  chronic_risk: chronic_risk,
                },
              })
              setIsTrackDataLoaded(true)
              extendCookie()
            }
          })
          .catch((e) => {
            console.log('getTrack error', e)
            sendDiscordNotification(`getTrack Error \n Error: ${e} `)
            alert('伺服器忙線中，請稍後再試')
          })
          .finally(() => {
            // setIsCardLoading(false)
            clearTimeout(loadingTimer)
          })
      } else {
        // TODO:
      }
    }
  }, [currentUser, patient_id])

  // error classname
  function getClassName(errors, touched, fieldName) {
    if (fieldName.includes('.')) {
      const fieldParts = fieldName.split('.')
      let currentError = errors
      let currentTouched = touched

      for (const part of fieldParts) {
        if (currentError && currentTouched) {
          currentError = currentError[part]
          currentTouched = currentTouched[part]
        } else {
          break
        }
      }
      return currentError && currentTouched
        ? 'border border-danger border-2'
        : ''
    } else {
      return errors[fieldName] && touched[fieldName]
        ? 'border border-danger border-2'
        : ''
    }
  }

  // error message
  function renderErrorMessage(errors, touched, fieldName) {
    if (fieldName.includes('.')) {
      const fieldParts = fieldName.split('.')
      let currentError = errors
      let currentTouched = touched

      for (const part of fieldParts) {
        if (currentError && currentTouched) {
          currentError = currentError[part]
          currentTouched = currentTouched[part]
        } else {
          break
        }
      }
      return currentError && currentTouched ? (
        <div className="error-message">{currentError}</div>
      ) : null
    } else {
      return errors[fieldName] && touched[fieldName] ? (
        <div className="error-message">{errors[fieldName]}</div>
      ) : null
    }
  }

  // Form submit handler
  const handleSubmit = (values) => {
    // Process form data here
    console.log('handleSubmit', values)
    const newFormData = {
      ...values,
      track_form: {
        ...values.track_form,
        indicator: {
          ...values.track_form?.indicator,
          bmi: (
            values.track_form.info.weight /
            Math.pow(values.track_form.info.height / 100, 2)
          ).toFixed(2),
        },
      },
    }

    setFormData(newFormData)
    setFormConfirmShow(true)
    topFunction()
  }
  // Validation Schema using Yup
  const RecordSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, '病人姓名至少為 2 個字元')
      .max(20, '病人姓名最多為 20 個字元')
      .required('病人姓名為必填項目'),
    gender: Yup.string().required('請選擇性別'),
    birthday: Yup.date().required('生日為必填項目'),
    track_form: Yup.object({
      info: Yup.object({
        height: Yup.number()
          .required('身高為必填項目')
          .min(99, '身高不能低於 99 公分')
          .max(300, '身高不能超過 300 公分')
          .positive('身高必須為正數'),
        weight: Yup.number()
          .required('體重為必填項目')
          .min(30, '體重不能低於 30 公斤')
          .max(299, '體重不能超過 299 公斤')
          .positive('體重必須為正數'),
        exercise_habit_type: Yup.string().required('運動習慣為必填項目'),
        smoke_habit_type: Yup.string().required('吸煙習慣為必填項目'),
        betel_nut_habit_type: Yup.string().required('嚼檳榔習慣為必填項目'),
      }),
      chronic_risk: Yup.object({
        cad_risk_type: Yup.string().required('冠心病風險為必填項目'),
        diabetes_risk_type: Yup.string().required('糖尿病風險為必填項目'),
        hypertension_risk_type: Yup.string().required('高血壓風險為必填項目'),
        stroke_risk_type: Yup.string().required('腦中風風險為必填項目'),
        cvd_risk_type: Yup.string().required('心血管不良事件風險為必填項目'),
      }),
      indicator: Yup.object({
        waistline: Yup.number()
          .required('腰圍為必填項目')
          .min(10, '腰圍不能低於 10 公分')
          .max(250, '腰圍不能超過 250 公分')
          .positive('腰圍必須為正數'),
        blood_sugar_before_meal: Yup.number()
          .required('飯前血糖值為必填項目')
          .min(30, '飯前血糖值不能低於 30 mg/dL')
          .max(300, '飯前血糖值不能超過 300 mg/dL')
          .positive('飯前血糖值必須為正數'),
        sbp: Yup.number()
          .required('收縮壓為必填項目')
          .min(50, '收縮壓不能低於 50 mmHg')
          .max(350, '收縮壓不能超過 350 mmHg')
          .positive('收縮壓必須為正數'),
        dbp: Yup.number()
          .required('舒張壓為必填項目')
          .min(30, '舒張壓不能低於 30 mmHg')
          .max(200, '舒張壓不能超過 200 mmHg')
          .positive('舒張壓必須為正數'),
        tg: Yup.number()
          .required('三酸甘油脂值為必填項目')
          .min(9, '三酸甘油脂值不能低於 9 mg/dL')
          .max(999, '三酸甘油脂值不能超過 999 mg/dL')
          .positive('三酸甘油脂值必須為正數'),
        hdl: Yup.number()
          .required('高密度脂蛋白膽固醇值為必填項目')
          .min(5, '高密度脂蛋白膽固醇值不能低於 5 mg/dL')
          .max(200, '高密度脂蛋白膽固醇值不能超過 200 mg/dL')
          .positive('高密度脂蛋白膽固醇值必須為正數'),
      }),
      guidelines: Yup.object({
        quit_smoking: Yup.object({
          // check: Yup.number()
          //   // 使用 .when() 方法对 check 字段设置条件验证
          //   .when('quit_smoking_type', {
          //     is: (quit_smoking_type) => quit_smoking_type !== '',
          //     then: Yup.number().required('若有選擇戒煙類型，則此欄位為必填'),
          //     otherwise: Yup.number(),
          //   }),
          // quit_smoking_type: Yup.string()
          //   // 对 quit_smoking_type 字段设置条件验证
          //   .when('check', {
          //     is: (check) => check !== 0,
          //     then: Yup.string().required('若有勾選戒煙檢查，則需選擇戒煙類型'),
          //     otherwise: Yup.string(),
          //   }),
        }),
      }),
    }),
  })
  const chronicRiskTypeArr = ['高風險', '中風險', '低風險', '不適用']

  // TODO 將 Modal 滾動到頂部
  function topFunction() {
    const modalContent = document.querySelector('.modal-content')
    if (modalContent) {
      modalContent.scrollTop = 0
    }
  }

  // demo
  const demo = () => {
    setFormData({
      name: '',
      gender: '0',
      birthday: '1985-05-07',
      track_form: {
        info: {
          height: 170,
          weight: 105,
          exercise_habit_type: '1',
          smoke_habit_type: '4',
          betel_nut_habit_type: '2',
        },
        chronic_risk: {
          cad_risk_type: '2',
          diabetes_risk_type: '3',
          hypertension_risk_type: '1',
          stroke_risk_type: '3',
          cvd_risk_type: '4',
        },
        indicator: {
          waistline: 95,
          blood_sugar_before_meal: 103,
          sbp: 140,
          dbp: 86,
          tg: 162,
          hdl: 48,
        },
        guidelines: {
          quit_smoking: {
            check: 1,
            quit_smoking_type: '1',
            service_type: '0',
          },
          quit_betel_nut: {
            check: 1,
            quit_betel_nut_type: ['1', '0'],
            target_date: '2024-07-27',
            oral_mucosa_check_date: '2024-10',
          },
          food: {
            check: 1,
            caloric_intake_type: '2',
            caloric: '',
            reduce_food_type: ['friedFood', 'sweets', 'sugaryDrinks'],
            other_food_type: '',
          },
          exercise: {
            check: 1,
            exercise_type: ['0'],
            resource: [],
          },
          target_indicator: {
            check: 0,
            target_waistline: '',
            target_weight: '',
          },
          blood_pressure_check: {
            check: 1,
          },
          other: {
            check: 1,
            other_type: ['hdl', 'blood_sugar'],
            HbA1c_before_meal_target: '',
            blood_sugar_before_meal_target: 90,
            tg_target: '',
            hdl_target: 40,
            ldl_target: '',
          },
        },
      },
    })
    console.log('demo')
  }
  return (
    <>
      <Modal
        show={caseModalShow}
        dialogClassName="formModalWidth"
        className="metabolic-syndrome-form"
      >
        {currentPatient &&
          !formConfirmShow &&
          trackFormData.data.length > 0 && (
            <>
              <Nav
                variant="pills"
                defaultActiveKey={`tracking-${trackFormData.data.length}`}
                className="m-3"
              >
                <Nav.Item>
                  <Nav.Link
                    eventKey="tracking-0"
                    onClick={() => {
                      setCurrentTrackIndex(0)
                    }}
                  >
                    新案
                  </Nav.Link>
                </Nav.Item>

                <>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="tracking-1"
                      onClick={() => {
                        setCurrentTrackIndex(1)
                      }}
                    >
                      追蹤 1
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="tracking-2"
                      disabled={trackFormData.data.length < 2}
                      onClick={() => {
                        setCurrentTrackIndex(2)
                      }}
                    >
                      追蹤 2
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="tracking-3"
                      disabled={trackFormData.data.length < 3}
                      onClick={() => {
                        setCurrentTrackIndex(3)
                      }}
                    >
                      追蹤 3
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="tracking-4"
                      disabled={trackFormData.data.length < 4}
                      onClick={() => {
                        setCurrentTrackIndex(4)
                      }}
                    >
                      追蹤 4
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="tracking-5"
                      disabled={trackFormData.data.length < 5}
                      onClick={() => {
                        setCurrentTrackIndex(5)
                      }}
                    >
                      年度評估
                    </Nav.Link>
                  </Nav.Item>
                </>
              </Nav>
            </>
          )}
        <h4
          className="m-4 text-center fw-bold"
          onClick={() => {
            demo()
          }}
        >
          代謝症候群疾病管理紀錄表（交付收案對象）
        </h4>
        <CloseButton
          onClick={() => {
            setWarning({
              ...warning,
              show: true,
              msg: '退出後本次資料不儲存',
              confirmMsg: '確認退出',
              onConfirm: () => {
                setCaseModalShow(false)
              },
              onCancel: () => {},
            })
          }}
          className="position-absolute"
          style={{ top: '10px', right: '10px' }}
        />
        {/* 新案/追蹤 */}
        {!formConfirmShow && currentTrackIndex >= trackFormData.data.length && (
          <Formik
            initialValues={
              isTrackDataLoaded ? lastTrackFormData || formData : formData
            }
            enableReinitialize={true}
            // TODO yup schema 加回來
            validationSchema={RecordSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              // Handle form submission, e.g., send data to an API
              console.log(values)
              handleSubmit(values)
              // Example: Setting a status message after submission
              // setStatus({ submitted: true });

              // Reset the form after successful submission
              resetForm(false)

              // Set submitting to false after form is handled
              setSubmitting(false)
            }}
          >
            {({
              errors,
              touched,
              isSubmitting,
              status,
              setFieldValue,
              values,
            }) => (
              <Form className="overflow-x-hidden mx-4 mx-lg-5 ">
                {/* 姓名 */}
                <Row className="text-center name" xs={3}>
                  {/* Patient Name Field */}
                  <Col>
                    <div className="form-section">
                      <label htmlFor="name">病人姓名：</label>
                      {isTrackDataLoaded ? (
                        <>
                          <span className="h5">{lastTrackFormData.name}</span>
                        </>
                      ) : (
                        <Field
                          name="name"
                          type="text"
                          className={`w-100 ${getClassName(errors, touched, 'name')}`}
                        />
                      )}

                      {renderErrorMessage(errors, touched, 'name')}
                    </div>
                  </Col>

                  {/* Assessment Type Field */}
                  <Col>
                    <div className="form-section">
                      <label>性別：</label>
                      {isTrackDataLoaded ? (
                        <span className="h5">
                          {lastTrackFormData.gender === Number('1')
                            ? '男'
                            : '女'}
                        </span>
                      ) : (
                        <div
                          role="group"
                          aria-labelledby="gender-radio-group"
                          className="mt-2"
                        >
                          <label>
                            <Field type="radio" name="gender" value="1" />男
                          </label>
                          <label>
                            <Field type="radio" name="gender" value="0" />女
                          </label>
                        </div>
                      )}

                      {renderErrorMessage(errors, touched, 'gender')}
                    </div>
                  </Col>
                  <Col>
                    <div className="form-section">
                      <label htmlFor="birthday">生日：</label>
                      {isTrackDataLoaded ? (
                        <span className="h5">{lastTrackFormData.birthday}</span>
                      ) : (
                        <DatePicker
                          className="w-100"
                          name="birthday"
                          dateFormat="yyyy/MM/dd"
                          selected={values.birthday}
                          onChange={(date) =>
                            setFieldValue(
                              'birthday',
                              dayjs(date).format('YYYY-MM-DD')
                            )
                          }
                        />
                      )}
                      {renderErrorMessage(errors, touched, 'birthday')}
                    </div>
                  </Col>
                </Row>
                <Row xs={2} className="basicInfoAndChronicDiseaseRisk">
                  {/* 基本資料與生活習慣 */}
                  <Col className="border border-light-subtle border-1 border-end-0">
                    <div className="basicInfo">
                      <h5 className="m-2">基本資料與生活習慣</h5>
                      {/* Height Field */}
                      <div className="form-section">
                        <label htmlFor="track_form.info.height">
                          身高（公分）：
                        </label>
                        <Field
                          name="track_form.info.height"
                          type="number"
                          className={getClassName(
                            errors,
                            touched,
                            'track_form.info.height'
                          )}
                        />
                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.info.height'
                        )}
                      </div>

                      {/* Weight Field */}
                      <div className="form-section">
                        <label htmlFor="track_form.info.weight">
                          體重（公斤）：
                        </label>
                        <Field
                          className={getClassName(
                            errors,
                            touched,
                            'track_form.info.weight'
                          )}
                          name="track_form.info.weight"
                          type="number"
                        />
                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.info.weight'
                        )}
                      </div>

                      {/* Exercise Field */}
                      <div className="form-section">
                        <label>運動：</label>
                        <Field
                          className={getClassName(
                            errors,
                            touched,
                            'track_form.info.exercise_habit_type'
                          )}
                          as="select"
                          name="track_form.info.exercise_habit_type"
                        >
                          <option value="">選擇</option>
                          <option value="1">1.無</option>
                          <option value="2">2.偶爾</option>
                          <option value="3">3.經常(每週累計達 150 分鐘)</option>
                        </Field>
                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.info.exercise_habit_type'
                        )}
                      </div>

                      {/* Smoking Field */}
                      <div className="form-section">
                        <label>抽菸：</label>
                        <Field
                          className={getClassName(
                            errors,
                            touched,
                            'track_form.info.smoke_habit_type'
                          )}
                          as="select"
                          name="track_form.info.smoke_habit_type"
                        >
                          <option value="">選擇</option>
                          <option value="1">1.無</option>
                          <option value="2">2.偶爾</option>
                          <option value="3">3.平均一天約吸 10 支菸以下</option>
                          <option value="4">
                            4.平均一天約吸 10 支菸（含）以上
                          </option>
                        </Field>
                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.info.smoke_habit_type'
                        )}
                      </div>

                      {/* Betel Nut Chewing Field */}
                      <div className="form-section">
                        <label>嚼檳榔：</label>
                        <Field
                          className={getClassName(
                            errors,
                            touched,
                            'track_form.info.betel_nut_habit_type'
                          )}
                          as="select"
                          name="track_form.info.betel_nut_habit_type"
                        >
                          <option value="">選擇</option>
                          <option value="1">1.無</option>
                          <option value="2">2.偶爾</option>
                          <option value="3">3.經常</option>
                        </Field>
                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.info.betel_nut_habit_type'
                        )}
                      </div>
                    </div>
                  </Col>
                  {/* 得到慢性病的風險 */}
                  <Col className="border border-light-subtle border-1">
                    {/* Chronic Disease Risk Assessment Fields */}
                    {/* TODO: 收案時變成必填  */}
                    <div className="chronicDiseaseRisk">
                      <h5 className="m-2">
                        得到慢性病的風險
                        <span className="h6">（僅需收案時評估）</span>
                      </h5>
                      <div className="form-section">
                        <label>冠心病：</label>{' '}
                        {isTrackDataLoaded ? (
                          <>
                            <span className="h5">
                              {
                                chronicRiskTypeArr[
                                  lastTrackFormData.track_form.chronic_risk
                                    .cad_risk_type - 1
                                ]
                              }
                            </span>
                          </>
                        ) : (
                          <Field
                            className={getClassName(
                              errors,
                              touched,
                              'track_form.chronic_risk.cad_risk_type'
                            )}
                            as="select"
                            name="track_form.chronic_risk.cad_risk_type"
                          >
                            <option value="">選擇</option>
                            <option value="1">高風險</option>
                            <option value="2">中風險</option>
                            <option value="3">低風險</option>
                            <option value="4">不適用</option>
                          </Field>
                        )}
                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.chronic_risk.cad_risk_type'
                        )}
                      </div>
                      <div className="form-section">
                        <label>糖尿病：</label>
                        {isTrackDataLoaded ? (
                          <>
                            <span className="h5">
                              {
                                chronicRiskTypeArr[
                                  lastTrackFormData.track_form.chronic_risk
                                    .diabetes_risk_type - 1
                                ]
                              }
                            </span>
                          </>
                        ) : (
                          <Field
                            className={getClassName(
                              errors,
                              touched,
                              'track_form.chronic_risk.diabetes_risk_type'
                            )}
                            as="select"
                            name="track_form.chronic_risk.diabetes_risk_type"
                          >
                            <option value="">選擇</option>
                            <option value="1">高風險</option>
                            <option value="2">中風險</option>
                            <option value="3">低風險</option>
                            <option value="4">不適用</option>
                          </Field>
                        )}

                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.chronic_risk.diabetes_risk_type'
                        )}
                      </div>
                      <div className="form-section">
                        <label>高血壓：</label>
                        {isTrackDataLoaded ? (
                          <>
                            <span className="h5">
                              {
                                chronicRiskTypeArr[
                                  lastTrackFormData.track_form.chronic_risk
                                    .hypertension_risk_type - 1
                                ]
                              }
                            </span>
                          </>
                        ) : (
                          <Field
                            className={getClassName(
                              errors,
                              touched,
                              'track_form.chronic_risk.hypertension_risk_type'
                            )}
                            as="select"
                            name="track_form.chronic_risk.hypertension_risk_type"
                          >
                            <option value="">選擇</option>
                            <option value="1">高風險</option>
                            <option value="2">中風險</option>
                            <option value="3">低風險</option>
                            <option value="4">不適用</option>
                          </Field>
                        )}

                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.chronic_risk.hypertension_risk_type'
                        )}
                      </div>
                      <div className="form-section">
                        <label>腦中風：</label>
                        {isTrackDataLoaded ? (
                          <>
                            <span className="h5">
                              {
                                chronicRiskTypeArr[
                                  lastTrackFormData.track_form.chronic_risk
                                    .stroke_risk_type - 1
                                ]
                              }
                            </span>
                          </>
                        ) : (
                          <Field
                            className={getClassName(
                              errors,
                              touched,
                              'track_form.chronic_risk.stroke_risk_type'
                            )}
                            as="select"
                            name="track_form.chronic_risk.stroke_risk_type"
                          >
                            <option value="">選擇</option>
                            <option value="1">高風險</option>
                            <option value="2">中風險</option>
                            <option value="3">低風險</option>
                            <option value="4">不適用</option>
                          </Field>
                        )}

                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.chronic_risk.stroke_risk_type'
                        )}
                      </div>
                      <div className="form-section">
                        <label>心血管不良事件：</label>
                        {isTrackDataLoaded ? (
                          <>
                            <span className="h5">
                              {
                                chronicRiskTypeArr[
                                  lastTrackFormData.track_form.chronic_risk
                                    .cvd_risk_type - 1
                                ]
                              }
                            </span>
                          </>
                        ) : (
                          <Field
                            className={getClassName(
                              errors,
                              touched,
                              'track_form.chronic_risk.cvd_risk_type'
                            )}
                            as="select"
                            name="track_form.chronic_risk.cvd_risk_type"
                          >
                            <option value="">選擇</option>
                            <option value="1">高風險</option>
                            <option value="2">中風險</option>
                            <option value="3">低風險</option>
                            <option value="4">不適用</option>
                          </Field>
                        )}

                        {renderErrorMessage(
                          errors,
                          touched,
                          'track_form.chronic_risk.cvd_risk_type'
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* 代謝症候群五大指標 */}
                <div className="metabolicIndicators border border-light-subtle border-1 border-end border-start px-3 pb-3">
                  {' '}
                  <h5 className="m-2 mt-4">
                    代謝症候群五大指標及身體質量指數（參考值）
                  </h5>
                  <div className="form-section">
                    <label>腰圍（公分）：</label>
                    <Field
                      placeholder="（男性 ≧ 90 公分，女性 ≧ 80 公分）"
                      className={getClassName(
                        errors,
                        touched,
                        'track_form.indicator.waistline'
                      )}
                      name="track_form.indicator.waistline"
                      type="number"
                    />
                    {renderErrorMessage(
                      errors,
                      touched,
                      'track_form.indicator.waistline'
                    )}
                  </div>
                  <div className="form-section">
                    <label>飯前血糖值（mg/dL）：</label>
                    <Field
                      placeholder="（≧ 100 mg/dL）"
                      className={getClassName(
                        errors,
                        touched,
                        'track_form.indicator.blood_sugar_before_meal'
                      )}
                      name="track_form.indicator.blood_sugar_before_meal"
                      type="number"
                    />
                    {renderErrorMessage(
                      errors,
                      touched,
                      'track_form.indicator.blood_sugar_before_meal'
                    )}
                  </div>
                  <div className="d-flex">
                    <div className="w-50 form-section">
                      <label>收縮壓：</label>
                      <Field
                        placeholder="≧ 130 mmHg"
                        className={getClassName(
                          errors,
                          touched,
                          'track_form.indicator.sbp'
                        )}
                        name="track_form.indicator.sbp"
                        type="number"
                      />
                      {renderErrorMessage(
                        errors,
                        touched,
                        'track_form.indicator.sbp'
                      )}
                    </div>

                    <div className="w-50 form-section">
                      <label>舒張壓：</label>
                      <Field
                        placeholder="≧ 85 mmHg"
                        className={getClassName(
                          errors,
                          touched,
                          'track_form.indicator.dbp'
                        )}
                        name="track_form.indicator.dbp"
                        type="number"
                      />
                      {renderErrorMessage(
                        errors,
                        touched,
                        'track_form.indicator.dbp'
                      )}
                    </div>
                  </div>
                  <div className="form-section">
                    <label>三酸甘油脂值（mg/dL）：</label>
                    <Field
                      placeholder="（≧ 150 mg/dL）"
                      className={getClassName(
                        errors,
                        touched,
                        'track_form.indicator.tg'
                      )}
                      name="track_form.indicator.tg"
                      type="number"
                    />
                    {renderErrorMessage(
                      errors,
                      touched,
                      'track_form.indicator.tg'
                    )}
                  </div>
                  <div className="form-section">
                    <label>高密度脂蛋白膽固醇值（mg/dL）：</label>
                    <Field
                      placeholder="（男性 ＜ 40 mg/dL，女性 ＜ 50 mg/dL）"
                      className={getClassName(
                        errors,
                        touched,
                        'track_form.indicator.hdl'
                      )}
                      name="track_form.indicator.hdl"
                      type="number"
                    />
                    {renderErrorMessage(
                      errors,
                      touched,
                      'track_form.indicator.hdl'
                    )}
                  </div>
                  <div className="form-section">
                    <label>
                      {/* TODO 自動算 */}
                      身體質量指數（kg/m<sup>2</sup>）BMI：
                    </label>
                    {values.track_form.info.weight &&
                    values.track_form.info.height
                      ? (
                          values.track_form.info.weight /
                          Math.pow(values.track_form.info.height / 100, 2)
                        ).toFixed(2)
                      : ''}
                  </div>
                </div>

                {/* 疾病管理指引 */}
                <div className="diseaseManagementGuidelines border border-secondary border-3 px-3 pb-3">
                  <h5 className="m-2 mt-4">
                    疾病管理指引
                    <span className="h6">
                      （醫師對病人說明治療用藥外，亦須改善危險因子的重要性）
                    </span>
                  </h5>
                  <div className="form-section">
                    <div
                      role="group"
                      aria-labelledby="quitSmoking-radio-group"
                      className="mt-2"
                    >
                      <label>
                        <Field
                          type="checkbox"
                          name="track_form.guidelines.quit_smoking.check"
                          value="1"
                          checked={
                            values.track_form.guidelines.quit_smoking.check ===
                            1
                          }
                          onChange={() => {
                            const currentValue =
                              values.track_form.guidelines.quit_smoking.check
                            setFieldValue(
                              'track_form.guidelines.quit_smoking.check',
                              currentValue === 1 ? 0 : 1
                            )
                          }}
                          // onChange={(e) => {
                          //   if (!e.target.checked) {
                          //     setFieldValue(
                          //       'track_form.guidelines.quit_smoking.check',
                          //       false
                          //     )
                          //     setFieldValue(
                          //       'diseaseManagementGuidelines.quitSmoking.guidanceOrServices',
                          //       ''
                          //     )
                          //     setFieldValue(
                          //       'diseaseManagementGuidelines.quitSmoking.cessationServices',
                          //       ''
                          //     )
                          //   } else {
                          //     setFieldValue(
                          //       'diseaseManagementGuidelines.quitSmoking.quitSmoking',
                          //       true
                          //     )
                          //   }
                          // }}
                        />
                        戒菸（吸菸 ≧ 10 支/日或尼古丁成癮度 ≧ 4
                        分，可提供或轉介戒菸服務）
                      </label>
                      <div className="ms-3">
                        <label>
                          <Field
                            type="radio"
                            name="track_form.guidelines.quit_smoking.quit_smoking_type"
                            value="0"
                            // onChange={() => {
                            //   setFieldValue(
                            //     'diseaseManagementGuidelines.quitSmoking.quitSmoking',
                            //     true
                            //   )
                            //   setFieldValue(
                            //     'diseaseManagementGuidelines.quitSmoking.guidanceOrServices',
                            //     'guidance'
                            //   )
                            // }}
                          />
                          戒菸指導（無意願接受戒菸服務或 ＜ 10
                          支/日或尼古丁成癮度 ＜ 4 分）
                        </label>
                        <label>
                          <Field
                            type="radio"
                            name="track_form.guidelines.quit_smoking.quit_smoking_type"
                            value="1"
                            // onChange={() => {
                            //   setFieldValue(
                            //     'diseaseManagementGuidelines.quitSmoking.quitSmoking',
                            //     true
                            //   )
                            //   setFieldValue(
                            //     'diseaseManagementGuidelines.quitSmoking.guidanceOrServices',
                            //     'services'
                            //   )
                            // }}
                          />
                          戒菸服務（≧ 10 支/日或尼古丁成癮度 ≧ 4 分）：
                        </label>
                        <div className="ms-3">
                          <label>
                            <Field
                              type="radio"
                              name="track_form.guidelines.quit_smoking.service_type"
                              value="0"
                              // onChange={() => {
                              //   setFieldValue(
                              //     'diseaseManagementGuidelines.quitSmoking.quitSmoking',
                              //     true
                              //   )
                              //   setFieldValue(
                              //     'diseaseManagementGuidelines.quitSmoking.guidanceOrServices',
                              //     'services'
                              //   )
                              //   setFieldValue(
                              //     'diseaseManagementGuidelines.quitSmoking.cessationServices',
                              //     'provided'
                              //   )
                              // }}
                            />
                            提供戒菸服務
                          </label>
                          <label>
                            <Field
                              type="radio"
                              name="track_form.guidelines.quit_smoking.service_type"
                              value="1"

                              // onChange={() => {
                              //   setFieldValue(
                              //     'diseaseManagementGuidelines.quitSmoking.quitSmoking',
                              //     true
                              //   )
                              //   setFieldValue(
                              //     'diseaseManagementGuidelines.quitSmoking.guidanceOrServices',
                              //     'services'
                              //   )
                              //   setFieldValue(
                              //     'diseaseManagementGuidelines.quitSmoking.cessationServices',
                              //     'referrals'
                              //   )
                              // }}
                            />
                            同意轉介戒菸服務
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-section">
                    <div
                      role="group"
                      aria-labelledby="track_form.guidelines.quit_betel_nut.check"
                      className="mt-2"
                    >
                      <label>
                        <Field
                          type="checkbox"
                          name="track_form.guidelines.quit_betel_nut.check"
                          value="1"
                          checked={
                            values.track_form.guidelines.quit_betel_nut
                              .check === 1
                          }
                          onChange={() => {
                            const currentValue =
                              values.track_form.guidelines.quit_betel_nut.check
                            setFieldValue(
                              'track_form.guidelines.quit_betel_nut.check',
                              currentValue === 1 ? 0 : 1
                            )
                          }}

                          // value="quitBetelNut"
                          // checked={
                          //   values.diseaseManagementGuidelines.quitBetelNut
                          //     .cessationGoal ||
                          //   values.diseaseManagementGuidelines.quitBetelNut
                          //     .oralExamScheduled ||
                          //   values.diseaseManagementGuidelines.quitBetelNut
                          //     .quitBetelNut
                          // }
                        />
                        戒檳（6 個月內有嚼檳榔）
                      </label>
                      <div className="ms-3">
                        <div>
                          <label>
                            <Field
                              type="checkbox"
                              name="track_form.guidelines.quit_betel_nut.quit_betel_nut_type"
                              value="0"
                              // checked={
                              //   values.diseaseManagementGuidelines.quitBetelNut
                              //     .cessationGoal ||
                              //   Boolean(
                              //     values.diseaseManagementGuidelines
                              //       .quitBetelNut.cessationGoalDate
                              //   )
                              // }
                            />
                            戒檳目標：
                          </label>
                          {/* TODO: 1.判斷超過原日期 2.有填就 checked */}
                          <DatePicker
                            // isClearable={Boolean(
                            //   values.diseaseManagementGuidelines.quitBetelNut
                            //     .cessationGoalDate
                            // )}
                            name="track_form.guidelines.quit_betel_nut.target_date"
                            selected={
                              values.track_form.guidelines.quit_betel_nut
                                .target_date
                            }
                            dateFormat="yyyy/MM/dd"
                            onChange={(date) => {
                              setFieldValue(
                                'track_form.guidelines.quit_betel_nut.target_date',
                                dayjs(date).format('YYYY-MM-DD')
                              )
                              // if (date) {
                              //   setFieldValue(
                              //     'diseaseManagementGuidelines.quitBetelNut.cessationGoal',
                              //     true
                              //   )
                              // }
                            }}
                          />
                          <span>前戒除檳榔</span>
                        </div>
                        <div>
                          <label>
                            <Field
                              type="checkbox"
                              name="track_form.guidelines.quit_betel_nut.quit_betel_nut_type"
                              value="1"
                              // checked={
                              //   values.diseaseManagementGuidelines.quitBetelNut
                              //     .oralExamScheduled ||
                              //   Boolean(
                              //     values.diseaseManagementGuidelines
                              //       .quitBetelNut.oralExamScheduledDate
                              //   )
                              // }
                            />
                            安排口腔黏膜檢查：
                          </label>
                          <DatePicker
                            // isClearable={Boolean(
                            //   values.diseaseManagementGuidelines.quitBetelNut
                            //     .oralExamScheduledDate
                            // )}
                            name="track_form.guidelines.quit_betel_nut.oral_mucosa_check_date"
                            showMonthYearPicker
                            dateFormat="yyyy/MM"
                            selected={
                              values.track_form.guidelines.quit_betel_nut
                                .oral_mucosa_check_date
                            }
                            onChange={(date) => {
                              setFieldValue(
                                'track_form.guidelines.quit_betel_nut.oral_mucosa_check_date',
                                dayjs(date).format('YYYY-MM')
                              )
                              // if (date) {
                              //   setFieldValue(
                              //     'diseaseManagementGuidelines.quitBetelNut.oralExamScheduled',
                              //     true
                              //   )
                              // }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-section">
                    <div
                      role="group"
                      aria-labelledby="track_form.guidelines.food"
                      className="mt-2"
                    >
                      <label>
                        <Field
                          type="checkbox"
                          name="track_form.guidelines.food.check"
                          value="1"
                          checked={
                            values.track_form.guidelines.food.check === 1
                          }
                          onChange={() => {
                            const currentValue =
                              values.track_form.guidelines.food.check
                            setFieldValue(
                              'track_form.guidelines.food.check',
                              currentValue === 1 ? 0 : 1
                            )
                          }}
                        />
                        每日建議攝取熱量（大卡/天）：
                      </label>
                      <div className="ms-3">
                        <label>
                          <Field
                            type="radio"
                            name="track_form.guidelines.food.caloric_intake_type"
                            value="1"
                          />
                          1200
                        </label>
                        <label>
                          <Field
                            type="radio"
                            name="track_form.guidelines.food.caloric_intake_type"
                            value="2"
                          />
                          1500
                        </label>
                        <label>
                          <Field
                            type="radio"
                            name="track_form.guidelines.food.caloric_intake_type"
                            value="3"
                          />
                          1800
                        </label>
                        <label>
                          <Field
                            type="radio"
                            name="track_form.guidelines.food.caloric_intake_type"
                            value="4"
                          />
                          2000
                        </label>
                        <label>
                          <Field
                            type="radio"
                            name="track_form.guidelines.food.caloric_intake_type"
                            value="5"
                          />
                          其他
                          <Field
                            name="track_form.guidelines.food.caloric"
                            type="number"
                          />
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-section">
                    <div
                      role="group"
                      aria-labelledby="track_form.guidelines.food.reduce_food_type"
                      className="mt-2"
                    >
                      <div className="ms-3">
                        盡量減少
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.food.reduce_food_type"
                            value="friedFood"
                          />
                          油炸物
                        </label>
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.food.reduce_food_type"
                            value="sweets"
                          />
                          甜食
                        </label>
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.food.reduce_food_type"
                            value="salt"
                          />
                          鹽
                        </label>
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.food.reduce_food_type"
                            value="sugaryDrinks"
                          />
                          含糖飲料
                        </label>
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.food.reduce_food_type"
                            value="others"
                          />
                          其他
                          <Field
                            name="track_form.guidelines.food.other_food_type"
                            type="text"
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-section">
                    <div
                      role="group"
                      aria-labelledby="track_form.guidelines.exercise"
                      className="mt-2"
                    >
                      <label>
                        <Field
                          type="checkbox"
                          name="track_form.guidelines.exercise.check"
                          value="1"
                          checked={
                            values.track_form.guidelines.exercise.check === 1
                          }
                          onChange={() => {
                            const currentValue =
                              values.track_form.guidelines.exercise.check
                            setFieldValue(
                              'track_form.guidelines.exercise.check',
                              currentValue === 1 ? 0 : 1
                            )
                          }}
                        />
                        運動建議：
                      </label>
                      <div className="ms-3">
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.exercise.exercise_type"
                            value="0"
                          />
                          提供運動指導:每週累積 150
                          分鐘中等費力運動（活動時仍可交談，但無法唱歌）
                        </label>
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.exercise.exercise_type"
                            value="1"
                          />
                          提供社區運動資源：
                          <Field
                            name="track_form.guidelines.exercise.resource"
                            type="text"
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-section">
                    <div
                      role="group"
                      aria-labelledby="track_form.guidelines.target_indicator"
                      className="mt-2"
                    >
                      <label>
                        <Field
                          type="checkbox"
                          name="track_form.guidelines.target_indicator.check"
                          value="1"
                          checked={
                            values.track_form.guidelines.target_indicator
                              .check === 1
                          }
                          onChange={() => {
                            const currentValue =
                              values.track_form.guidelines.target_indicator
                                .check
                            setFieldValue(
                              'track_form.guidelines.target_indicator.check',
                              currentValue === 1 ? 0 : 1
                            )
                          }}
                        />
                        想達成的腰圍及體重：
                      </label>
                      <div className="ms-3">
                        <label>
                          腰圍
                          <Field
                            name="track_form.guidelines.target_indicator.target_waistline"
                            type="number"
                            className="w-25"
                          />
                          公分、體重
                          <Field
                            name="track_form.guidelines.target_indicator.target_weight"
                            type="number"
                            className="w-25"
                          />
                          公斤
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-section">
                    <div className="mt-2">
                      <label>
                        <Field
                          type="checkbox"
                          name="track_form.guidelines.blood_pressure_check"
                          value="1"
                          checked={
                            values.track_form.guidelines.blood_pressure_check
                              .check === 1
                          }
                          onChange={() => {
                            const currentValue =
                              values.track_form.guidelines.blood_pressure_check
                                .check

                            setFieldValue(
                              'track_form.guidelines.blood_pressure_check.check',
                              currentValue === 1 ? 0 : 1
                            )
                          }}
                        />
                        量血壓：指導 722 量測
                      </label>
                    </div>
                  </div>
                  <div className="mt-2">
                    <label>
                      <Field
                        type="checkbox"
                        name="track_form.guidelines.other.check"
                        value="1"
                        checked={values.track_form.guidelines.other.check === 1}
                        onChange={() => {
                          const currentValue =
                            values.track_form.guidelines.other.check
                          setFieldValue(
                            'track_form.guidelines.other.check',
                            currentValue === 1 ? 0 : 1
                          )
                        }}
                      />
                      其他叮嚀：
                    </label>
                    <div className="ms-3">
                      <div className="form-section">
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.other.other_type"
                            value="blood_sugar"
                          />
                          飯前血糖個人目標值：
                        </label>
                        <Field
                          name="track_form.guidelines.other.blood_sugar_before_meal_target"
                          type="number"
                          className="w-25"
                        />
                        mg/dL（%）
                      </div>
                      <div className="form-section">
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.other.other_type"
                            value="HbA1c"
                          />
                          醣化血紅素個人目標值：
                        </label>
                        <Field
                          name="track_form.guidelines.other.HbA1c_before_meal_target"
                          type="number"
                          className="w-25"
                        />
                        mg/dL（%）
                      </div>
                      <div className="form-section">
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.other.other_type"
                            value="tg"
                          />
                          三酸甘油脂個人目標值：
                        </label>
                        <Field
                          name="track_form.guidelines.other.tg_target"
                          type="number"
                          className="w-25"
                        />
                        mg/dL
                      </div>
                      <div className="form-section">
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.other.other_type"
                            value="hdl"
                          />
                          高密度脂蛋白膽固醇個人目標值：
                        </label>
                        <Field
                          name="track_form.guidelines.other.hdl_target"
                          type="number"
                          className="w-25"
                        />
                        mg/dL
                      </div>
                      <div className="form-section">
                        <label>
                          <Field
                            type="checkbox"
                            name="track_form.guidelines.other.other_type"
                            value="ldl"
                          />
                          低密度脂蛋白膽固醇個人目標值：
                        </label>
                        <Field
                          name="track_form.guidelines.other.ldl_target"
                          type="number"
                          className="w-25"
                        />
                        mg/dL
                      </div>
                    </div>
                  </div>
                </div>

                <h6 className="fw-bold">
                  ※同意收案者，請提供個人連絡電話做為個案追蹤健康管理或衛生單位政策評估使用。
                </h6>
                <h6>
                  ※本表請參照國民健康署提供之「代謝症候群管理計畫照護流程與指導手冊」執行。
                </h6>
                <div className="d-flex gap-3">
                  {currentPatient && (
                    <Button
                      onClick={() => {
                        setCaseClosedModalShow(true)
                      }}
                      className="my-3 w-50"
                      variant="outline-primary"
                    >
                      結案
                    </Button>
                  )}
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className={`my-3 ${currentPatient ? 'w-50' : 'w-100'}`}
                  >
                    {/* TODO 放在下一步 */}
                    {/* {isSubmitting ? '提交中...' : '儲存'} */}
                    下一步：資料確認
                  </Button>
                </div>
                {/* Display a success message upon successful submission */}
                {status && status.submitted ? (
                  <div className="success-message">表單已成功提交！</div>
                ) : null}
              </Form>
            )}
          </Formik>
        )}

        {/* 追蹤 */}
        {currentPatient &&
          !formConfirmShow &&
          trackFormData &&
          currentTrackIndex < trackFormData.data.length && (
            <>
              <MetabolicPlanFormView
                trackFormData={trackFormData}
                currentTrackIndex={currentTrackIndex}
              />
            </>
          )}
        {/* 確認 */}
        {formConfirmShow && (
          <MetabolicPlanFormConfirm
            warning={warning}
            setWarning={setWarning}
            setQrcode={setQrcode}
            setCaseModalShow={setCaseModalShow}
            currentPatient={currentPatient}
            formData={formData}
            setFormConfirmShow={setFormConfirmShow}
            lastTrackFormData={lastTrackFormData}
            currentTrackIndex={currentTrackIndex}
            isTrackDataLoaded={isTrackDataLoaded}
          />
        )}
      </Modal>
    </>
  )
}

export default MetabolicPlanForm
